import React from 'react'

export default function Navbar() {
    return (
        <nav>
            <img src="Troll Face.png" className='nav-image' alt="Logo" />
            <h2 className='nav-title'>Meme Generator</h2>
            <h4 className='nav-tagline'>Welcome To Meme World!</h4>
        </nav>
    )
}
